import { render, staticRenderFns } from "./membership-category-group-table.vue?vue&type=template&id=4a4ce72c&scoped=true"
import script from "./membership-category-group-table.vue?vue&type=script&lang=js"
export * from "./membership-category-group-table.vue?vue&type=script&lang=js"
import style0 from "./membership-category-group-table.vue?vue&type=style&index=0&id=4a4ce72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4ce72c",
  null
  
)

export default component.exports